import React from 'react';
import { getDateLabel } from '../../../utils/inquiryUtils';

/**
 * 대화 중 날짜가 변경될 때 표시되는 구분선 컴포넌트.
 */
const DateSeparator = ({ date }) => {
    const label = getDateLabel(date);

    if (!label) return null;

    return (
        <div className="flex items-center justify-center my-6">
            <div className="flex-grow h-[1px] bg-gray-100"></div>
            <div className="mx-4 px-3 py-1 bg-gray-50/80 backdrop-blur-sm border border-gray-100 rounded-full shadow-sm">
                <span className="text-[11px] font-semibold text-gray-500 tracking-tight">
                    {label}
                </span>
            </div>
            <div className="flex-grow h-[1px] bg-gray-100"></div>
        </div>
    );
};

export default DateSeparator;
